import {getLocalAuth} from '@app/localStorage';
import {redirect} from 'react-router-dom';
import {ROUTE_BASE_ROOT, ROUTE_LOGIN} from '../RoutePathConstant';

export const authLoader = async () => {
  const auth = await getLocalAuth();

  if (!auth) {
    return redirect(ROUTE_BASE_ROOT + ROUTE_LOGIN);
  }
  return auth;
};
